var map = {
	"./3dmodel_active.svg": "0205",
	"./book-close_active.svg": "ef77",
	"./computer_active.svg": "3d12",
	"./folder_active.svg": "ae3b",
	"./image_active.svg": "cdc2",
	"./ipfs_active.svg": "7dc4",
	"./payment_active.svg": "0ecb",
	"./sound_active.svg": "0ed6",
	"./video_active.svg": "c397",
	"./web_active.svg": "d2c5",
	"./website_active.svg": "a35d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebf6";